import React, { useRef, useEffect } from "react";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
    Checkbox,
    ClickAwayListener,
    FormControlLabel, FormGroup,
    Grow,
    Hidden,
    IconButton,
    InputLabel,
    ListItemText,
    Paper,
    Popper,
    Toolbar,
    Chip,
    Menu,
    MenuItem,
    Select,
    Tooltip,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormLabel,
    FormControl,
    TextField,
    Typography
} from '@material-ui/core';
import {
    FilterList,
    ViewColumn,
    Search
} from '@material-ui/icons';
import RefreshIcon from '@material-ui/icons/Refresh';
import BranchFilter from './BranchFilter.js';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { units_settings } from "../../data";
import { useTranslation } from 'react-i18next';
import ColumnSelector from './ColumnSelector';

// Set the css styles
const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    tableTools: {
        display: 'flex',
    },
    iconButtons: {
        marginRight: theme.spacing(1),

    },
    chipItem: {
        marginRight: theme.spacing(2),
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(0.5),
        },
    },
    filterContainer: {
        display: 'flex',
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
        padding: theme.spacing(1),
    },
    formControl: {
        display: 'inline-block',
        float: 'left',
        marginTop: '10px',
        marginRight: '5px',

    },
    formSubControl: {
        display: 'inline-block',
        float: 'left',
        marginTop: '40px',
        marginRight: '5px',
    },
    recurrMenuText: {
        display: 'inline-block',
        marginLeft: '10px',
        marginRight: '10px',
    },
    recurrMenuButton: {
        marginLeft: '25px',
    },
}));

// Custom, theme checkbox component
const ThemeCheckbox = withStyles((theme) => ({
    root: {
        color: theme.palette.primary.contrastText,
        '&$checked': {
            color: theme.palette.primary.contrastText,
        },
    },
    checked: {},
}))((props) => <Checkbox color="default" {...props} />);

// TLM filter bar component
export default function TlmFilterBar(props) {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const [reportsMenu, setReportsMenu] = React.useState(null);
    const [isFiltersOpen, setIsFiltersOpen] = React.useState(false);
    const [filtersAnchor, setFiltersAnchor] = React.useState(null);
    const DTE_range = ["noFilter", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30"];
    const [openScheduleReports, setOpenScheduleReports] = React.useState(false);
    const [recurrTime, setRecurrTime] = React.useState("8:00");
    const [recurrMonthlyWeek, setRecurrMonthlyWeek] = React.useState(t("first"));
    const [recurrMonthlyFreq, setRecurrMonthlyFreq] = React.useState(1);
    const [recurrMonthlyDay, setRecurrMonthlyDay] = React.useState(t("monday"));
    const [recurringInput, setRecurringInput] = React.useState(t("never"));
    const [recurMenuState, setRecurMenuState] = React.useState({ show: false, weekly: false });
    const recurringInputRef = useRef(null);
    const [recurrUnits, setRecurringUnits] = React.useState("imperial");
    const [shift, setUTCShift] = React.useState(0);
    const [state, setState] = React.useState({
        monday: true,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
    });
    const disableScheduleReport = props.disableScheduleReport === undefined ? false : props.disableScheduleReport;
    const [openSearchDialogue, setOpenSearchDialogue] = React.useState(false);
    const [searchTerm, setSearchTerm] = React.useState("");
    const rsearchTerm = React.useRef("");

    const handleOpenSearch = () => {
        setOpenSearchDialogue(true);
    };
    const handleCloseSearch = () => {
        setOpenSearchDialogue(false);
    };
    const handleSearchTerm = () => {
        if(props.handleSearchTerm){
            props.handleSearchTerm(searchTerm);
        }
        setOpenSearchDialogue(false);
    };
    const handleClearSearchTerm = () => {
        setSearchTerm("");
        if(props.handleSearchTerm){
            props.handleSearchTerm("");
        }
    };

    const handleFiltersOpen = (event) => {
        setFiltersAnchor(event.currentTarget);
        setIsFiltersOpen(true);
    };

    const handleFiltersClose = () => {
        setIsFiltersOpen(false);
    };

    const handleDownloadCSV = () => {
        setReportsMenu(null);
        props.onCSVDownloadRequest();
    };

    const handleDownloadPDF = () => {
        setReportsMenu(null);
        props.onPDFDownloadRequest();
    };

    const handleScheduleReports = async () => {
        setOpenScheduleReports(true);
    };

    const handleRecurringReportsSaveEvent = () => {
        if ((recurMenuState.weekly) && !state.monday && !state.tuesday && !state.wednesday && !state.thursday && !state.friday && !state.saturday && !state.sunday) {
            alert(t("pleaseSelectAtLeastOne"));
            return;
        }

        props.onRecurringReportRequest(recurMenuState.show, recurMenuState.weekly, recurrTime, state, recurrMonthlyDay, recurrMonthlyWeek, recurrUnits, recurringInput);

        setOpenScheduleReports(false);
        setReportsMenu(null);
    };

    const handleClose = () => {
        setReportsMenu(null);
        setOpenScheduleReports(false);
    };
    
    function handleDelete(item) {
        var lfluid = props.filtersInfo.fluidName;
        var ltag = props.filtersInfo.tagName;
        var lstatus = props.filtersInfo.statusName;
        var lullage = props.filtersInfo.ullageRange;
        var lDTE = props.filtersInfo.DTE;
        var index = lfluid.indexOf(item);
        var lshowSensorWarning = props.filtersInfo.showSensorWarning;

        if (item === "ullage") {
            lullage = [0, 100];
        }

        if (item === "DTE") {
            lDTE = "noFilter";
        }
        console.log(item);
        if (item === "showSensorWarning"){
            lshowSensorWarning = 0;
        }

        if (index > -1) {
            lfluid.splice(index, 1);
        }

        index = ltag.indexOf(item);
        if (index > -1) {
            ltag.splice(index, 1);
        }

        index = lstatus.indexOf(item);
        if (index > -1) {
            lstatus.splice(index, 1);
        }

        props.setFilters({ 'fluidName': lfluid, 'statusName': lstatus, 'tagName': ltag, 'ullageRange': lullage, 'DTE': lDTE, 'showSensorWarning': lshowSensorWarning }, true);
    };

    const handleChange = name => event => {
        switch (name) {
            case 'monday':
                setState({ monday: event.target.checked, tuesday: state.tuesday, wednesday: state.wednesday, thursday: state.thursday, friday: state.friday, saturday: state.saturday, sunday: state.sunday });
                break;
            case 'tuesday':
                setState({ monday: state.monday, tuesday: event.target.checked, wednesday: state.wednesday, thursday: state.thursday, friday: state.friday, saturday: state.saturday, sunday: state.sunday });
                break;
            case 'wednesday':
                setState({ monday: state.monday, tuesday: state.tuesday, wednesday: event.target.checked, thursday: state.thursday, friday: state.friday, saturday: state.saturday, sunday: state.sunday });
                break;
            case 'thursday':
                setState({ monday: state.monday, tuesday: state.tuesday, wednesday: state.wednesday, thursday: event.target.checked, friday: state.friday, saturday: state.saturday, sunday: state.sunday });
                break;
            case 'friday':
                setState({ monday: state.monday, tuesday: state.tuesday, wednesday: state.wednesday, thursday: state.thursday, friday: event.target.checked, saturday: state.saturday, sunday: state.sunday });
                break;
            case 'saturday':
                setState({ monday: state.monday, tuesday: state.tuesday, wednesday: state.wednesday, thursday: state.thursday, friday: state.friday, saturday: event.target.checked, sunday: state.sunday });
                break;
            case 'sunday':
                setState({ monday: state.monday, tuesday: state.tuesday, wednesday: state.wednesday, thursday: state.thursday, friday: state.friday, saturday: state.saturday, sunday: event.target.checked });
                break;
        }
    };

    const handleMainRecurrChange = (event) => {
        switch (event.target.value) {
            case "Weekly":
                setRecurringInput("Weekly");
                setRecurMenuState({ show: true, weekly: true });
                break;
            case "Monthly":
                setRecurringInput("Monthly");
                setRecurMenuState({ show: true, weekly: false });
                break;
            case "Never":
                setRecurringInput("Never");
                setRecurMenuState({ show: false, weekly: false });
                break;
            case "FirstOfMonth":
                setRecurringInput("FirstOfMonth");
                setRecurMenuState({ show: true, weekly: false });
                break;
        };
    };

    const handleRecurrTimeSelect = (event) => {
        setRecurrTime(event.target.value);
    };

    const handleRecurrMonthlyDay = (event) => {
        setRecurrMonthlyDay(event.target.value);
    };

    const handleRecurrMonthlyWeek = (event) => {
        setRecurrMonthlyWeek(event.target.value);
    };

    const toggleReportsMenu = async (e) => {
        setReportsMenu(e.currentTarget);
        props.onGetUserRecurringReportRequest();
    };

    const handleRecurringReportsDeleteEvent = (event) => {
        setRecurringInput(t("never"));
        setRecurMenuState({ show: false, weekly: false });
        props.deleteRecurrentReportRequest();
        setOpenScheduleReports(false);
        setReportsMenu(null);
    };

    const handleRecurrUnitsSelect = (event) => {
        setRecurringUnits(event.target.value);
    };

    useEffect(() => {
        try {
            if (null !== props.reportingMenuItems) {
                let monthly = Boolean(Number(props.reportingMenuItems["monthly"]));
                let weekly = Boolean(Number(props.reportingMenuItems["weekly"]));
                let recurrTime = props.reportingMenuItems["recurr_time"];

                // Adjust UCT to client's timezone
                var clientTimeZoneOffset = new Date().getTimezoneOffset() / 60;
                recurrTime = (parseInt(recurrTime) - clientTimeZoneOffset);
                if (recurrTime > 23) {
                    recurrTime = recurrTime - 24;
                }
                if (recurrTime < 0) {
                    recurrTime = recurrTime + 24;
                }

                recurrTime = recurrTime.toString() + ':00';

                if (monthly) {
                    let utcShift = props.reportingMenuItems["utc_shift"];
                    setUTCShift(utcShift);

                    let frequency = props.reportingMenuItems["frequency"];
                    let monthlyDay = props.reportingMenuItems["monthly_day"];
                    let monthlyWeek = props.reportingMenuItems["monthly_week"];
                    let units = props.reportingMenuItems["units"];
                    if (monthlyDay == 'FirstOfMonth' || monthlyDay == 'SecondOfMonth' || monthlyDay == 'LastOfMonth') {
                        setRecurringInput("FirstOfMonth");
                    } else {
                        if (utcShift > 0) {
                            switch (monthlyDay) {
                                case 'Sunday':
                                    monthlyDay = t("saturday");
                                    break;
                                case 'Monday':
                                    monthlyDay = t("sunday");
                                    break;
                                case 'Tuesday':
                                    monthlyDay = t("monday");
                                    break;
                                case 'Wednesday':
                                    monthlyDay = t("tuesday");
                                    break;
                                case 'Thursday':
                                    monthlyDay = t("wednesday");
                                    break;
                                case 'Friday':
                                    monthlyDay = t("thursday");
                                    break;
                                case 'Saturday':
                                    monthlyDay = t("friday");
                                    break;
                            }
                        } else if (utcShift < 0) {
                            switch (monthlyDay) {
                                case 'Sunday':
                                    monthlyDay = t("monday");
                                    break;
                                case 'Monday':
                                    monthlyDay = t("tuesday");
                                    break;
                                case 'Tuesday':
                                    monthlyDay = t("wednesday");
                                    break;
                                case 'Wednesday':
                                    monthlyDay = t("thursday");
                                    break;
                                case 'Thursday':
                                    monthlyDay = t("friday");
                                    break;
                                case 'Friday':
                                    monthlyDay = t("saturday");
                                    break;
                                case 'Saturday':
                                    monthlyDay = t("sunday");
                                    break;
                            }
                        }

                        setRecurringInput("Monthly");
                    }

                    setRecurringUnits(units);
                    setRecurrMonthlyFreq(frequency);
                    setRecurrMonthlyDay(monthlyDay);
                    setRecurrMonthlyWeek(monthlyWeek);
                    setRecurrTime(recurrTime);
                    setRecurMenuState({ show: true, weekly: false });
                } else if (weekly) {
                    let utcShift = props.reportingMenuItems["utc_shift"];
                    setUTCShift(utcShift);

                    let mondayBool = Boolean(Number(props.reportingMenuItems["monday"]));
                    let tuesdayBool = Boolean(Number(props.reportingMenuItems["tuesday"]));
                    let wednesdayBool = Boolean(Number(props.reportingMenuItems["wednesday"]));
                    let thursdayBool = Boolean(Number(props.reportingMenuItems["thursday"]));
                    let fridayBool = Boolean(Number(props.reportingMenuItems["friday"]));
                    let saturdayBool = Boolean(Number(props.reportingMenuItems["saturday"]));
                    let sundayBool = Boolean(Number(props.reportingMenuItems["sunday"]));
                    let units = props.reportingMenuItems["units"];
                    var currState = { monday: mondayBool, tuesday: tuesdayBool, wednesday: wednesdayBool, thursday: thursdayBool, friday: fridayBool, saturday: saturdayBool, sunday: sundayBool };

                    var stateCopy = {};
                    stateCopy.sunday = utcShift === 1 ? currState.monday : utcShift === -1 ? currState.saturday : currState.sunday;
                    stateCopy.monday = utcShift === 1 ? currState.tuesday : utcShift === -1 ? currState.sunday : currState.monday;
                    stateCopy.tuesday = utcShift === 1 ? currState.wednesday : utcShift === -1 ? currState.monday : currState.tuesday;
                    stateCopy.wednesday = utcShift === 1 ? currState.thursday : utcShift === -1 ? currState.tuesday : currState.wednesday;
                    stateCopy.thursday = utcShift === 1 ? currState.friday : utcShift === -1 ? currState.wednesday : currState.thursday;
                    stateCopy.friday = utcShift === 1 ? currState.saturday : utcShift === -1 ? currState.thursday : currState.friday;
                    stateCopy.saturday = utcShift === 1 ? currState.sunday : utcShift === -1 ? currState.friday : currState.saturday;

                    setRecurringUnits(units);
                    setRecurrTime(recurrTime);
                    setState(stateCopy);
                    setRecurringInput(t("weekly"));
                    setRecurMenuState({ show: true, weekly: true });
                } else {
                    setUTCShift(0);
                    setRecurringInput(t("never"));
                    setRecurrTime("8:00");
                    setRecurrMonthlyWeek(t("first"));
                    setRecurrMonthlyDay(t("monday"));
                    setRecurringUnits("imperial");
                    setRecurMenuState({ show: false, weekly: false });
                    setState({ monday: true, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false });
                }
            }
        } catch (e) {

        }
    }, [props.reportingMenuItems]);

    return (
        <>
        <Hidden mdUp>
            <Toolbar>
                <div className={classes.grow} />
                <div className={classes.tableTools}>
                    <Select
                        id="units-dropdown"
                        value={props.displayUnits}
                        onChange={(event) => props.setDisplayUnits(event.target.value)}
                    >
                        {units_settings.map((Uval) => (
                            <MenuItem key={Uval.id} value={Uval.name}>
                                <ListItemText primary={t(Uval.label)} />
                            </MenuItem>
                        ))}
                    </Select>
                </div>
            </Toolbar>
        </Hidden>
        <Toolbar>
            <div className={classes.chipItem}>
                {props.filtersInfo.fluidName.map((fluid) => (
                    <Chip key={fluid} size="small" label={fluid} onDelete={e => handleDelete(fluid)} color="primary" />
                ))}
                {props.filtersInfo.tagName.map((tagName) => (
                    <Chip key={tagName} size="small" label={tagName} onDelete={e => handleDelete(tagName)} color="primary" />
                ))}
                {props.filtersInfo.statusName.map((statusName) => (
                    <Chip key={statusName} size="small" label={statusName} onDelete={e => handleDelete(statusName)} color="primary" />
                ))}
                {(props.filtersInfo.ullageRange.length > 0) && (true === (props.filtersInfo.ullageRange[0] !== 0 || props.filtersInfo.ullageRange[1] !== 100)) &&
                    <Chip size="small" label={t("ullage").concat(" ").concat(props.filtersInfo.ullageRange[0]).concat("% to ").concat(props.filtersInfo.ullageRange[1]).concat("%")}
                        onDelete={e => handleDelete("ullage")} color="primary" />}
                {(props.filtersInfo.DTE) && (props.filtersInfo.DTE !== "noFilter") &&
                    <Chip size="small" label={t("dte").concat(" < ").concat(t(props.filtersInfo.DTE))}
                        onDelete={e => handleDelete("DTE")} color="primary" />}
                {(props.filtersInfo.showSensorWarning === 1) &&
                    <Chip size="small" label={t("showSensorWarningChip")}
                        onDelete={e => handleDelete("showSensorWarning")} color="primary" />}
                {(props.currentSearchTerm) &&
                    <Chip size="small" label={props.currentSearchTerm}
                        onDelete={e => handleClearSearchTerm()} color="primary" />}
            </div>
            <div className={classes.grow} />
            <div className={classes.tableTools}>
                <Hidden smDown>
                    <Select
                        id="units-dropdown"
                        value={props.displayUnits}
                        onChange={(event) => props.setDisplayUnits(event.target.value)}
                    >
                        {units_settings.map((Uval) => (
                            <MenuItem key={Uval.id} value={Uval.name}>
                                <ListItemText primary={t(Uval.label)} />
                            </MenuItem>
                        ))}
                    </Select>
                </Hidden>
                {props.showRefresh && <Tooltip title={t('refresh')}>
                        <IconButton
                            aria-haspopup='true'
                            onClick={props.refreshFunction}
                            color='inherit'
                            className={classes.iconButtons}>
                            <RefreshIcon />
                        </IconButton>
                    </Tooltip>}
                
                <Tooltip title={t('search')}>
                    <IconButton
                        aria-haspopup='true'
                        onClick={handleOpenSearch}
                        color='inherit'
                        className={classes.iconButtons}>
                        <Search />
                    </IconButton>
                </Tooltip>
                {openSearchDialogue && <Dialog disableBackdropClick disableEscapeKeyDown open={openSearchDialogue} onClose={handleCloseSearch}>
                    <DialogTitle>{t("search")}</DialogTitle>
                    <DialogContent className={classes.root}>
                        <FormControl className={classes.formControl}>
                            <TextField type="test" label={t("name")}
                                inputRef={rsearchTerm}
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    }
                                }
                                />
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseSearch} color="primary">
                            {t("cancel")}
                        </Button>
                        <Button variant="contained" onClick={handleSearchTerm} color="primary" disabled={!searchTerm}>
                            {t("filter")}
                        </Button>
                    </DialogActions>
                </Dialog>}
                <BranchFilter
                    fluids={props.fluids}
                    statuses={[t("ok"), t("low"), t("critical"), t("comm"), t("batt")]}
                    DTE_range={DTE_range}
                    tags={props.tags}
                    filtersInfo={props.filtersInfo}
                    setFilters={props.setFilters} />

                {false && <Tooltip title={t("filters")}>
                    <IconButton
                        aria-haspopup='true'
                        onClick={handleFiltersOpen}
                        color='inherit'
                        className={classes.iconButtons}>
                        <FilterList />
                    </IconButton>
                </Tooltip>}

                <Popper
                    open={isFiltersOpen}
                    anchorEl={filtersAnchor}
                    placement='bottom-end'
                    transition
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper
                                elevation={3}
                                className={classes.filterContainer}
                                variant='outlined'
                            >
                                <ClickAwayListener onClickAway={handleFiltersClose}>
                                    <FormGroup row>
                                    </FormGroup>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>

                <Tooltip title={t("reports")}>
                    <IconButton
                        aria-haspopup='true'
                        color='inherit'
                        className={classes.iconButtons}
                        onClick={(e) => toggleReportsMenu(e)} >
                        <AssessmentIcon />
                    </IconButton>
                </Tooltip>
                <Menu
                    id="reports-menu"
                    open={Boolean(reportsMenu)}
                    anchorEl={reportsMenu}
                    onClose={() => setReportsMenu(null)}
                    disableAutoFocusItem>
                    <MenuItem
                        onClick={() => handleDownloadCSV()}>
                        {t("exportAsCsv")}
                    </MenuItem>
                    <MenuItem
                        onClick={() => handleDownloadPDF()}>
                        {t("exportAsPdf")}
                    </MenuItem>
                    {disableScheduleReport == false && <MenuItem
                        onClick={() => handleScheduleReports()}>
                        {t("schedule")}
                    </MenuItem>}
                </Menu>
                <Dialog open={openScheduleReports} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">{t("scheduledReports")}</DialogTitle>
                    <DialogContent>
                        <Typography>{t("tankLevelReport")}</Typography>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="age-native-simple">{t("recurring")}</InputLabel>

                            <Select native
                                value={recurringInput}
                                inputRef={recurringInputRef}
                                onChange={handleMainRecurrChange}>
                                <option value={"Never"}>{t("never")}</option>
                                <option value={"Weekly"}>{t("weekly")}</option>
                                <option value={"Monthly"}>{t("monthly")}</option>
                                <option value={"FirstOfMonth"}>{t("firstOfMonth")}</option>
                            </Select>

                            {recurMenuState.show &&
                                <span>
                                    <p className={classes.recurrMenuText}>{t("at")}</p>
                                    <Select native
                                        onChange={handleRecurrTimeSelect}
                                        value={recurrTime}>
                                        <option value={"24:00"}>0:00</option>
                                        <option value={"1:00"}>1:00</option>
                                        <option value={"2:00"}>2:00</option>
                                        <option value={"3:00"}>3:00</option>
                                        <option value={"4:00"}>4:00</option>
                                        <option value={"5:00"}>5:00</option>
                                        <option value={"6:00"}>6:00</option>
                                        <option value={"7:00"}>7:00</option>
                                        <option value={"8:00"}>8:00</option>
                                        <option value={"9:00"}>9:00</option>
                                        <option value={"10:00"}>10:00</option>
                                        <option value={"11:00"}>11:00</option>
                                        <option value={"12:00"}>12:00</option>
                                        <option value={"13:00"}>13:00</option>
                                        <option value={"14:00"}>14:00</option>
                                        <option value={"15:00"}>15:00</option>
                                        <option value={"16:00"}>16:00</option>
                                        <option value={"17:00"}>17:00</option>
                                        <option value={"18:00"}>18:00</option>
                                        <option value={"19:00"}>19:00</option>
                                        <option value={"20:00"}>20:00</option>
                                        <option value={"21:00"}>21:00</option>
                                        <option value={"22:00"}>22:00</option>
                                        <option value={"23:00"}>23:00</option>
                                    </Select>
                                    <p className={classes.recurrMenuText}>{t("units")}</p>
                                    <Select native
                                        id="recurring-report-units-dropdown"
                                        value={recurrUnits}
                                        onChange={handleRecurrUnitsSelect}>
                                        <option value={"imperial"}>{t("galIn")}</option>
                                        <option value={"metric"}>{t("lCm")}</option>
                                    </Select>
                                </span>
                            }
                        </FormControl>

                        {recurMenuState.show && (recurringInput == 'Weekly' || recurringInput == 'Monthly') &&
                            <div>
                                <FormControl className={classes.formSubControl}>
                                    {!recurMenuState.weekly ?
                                        <div>
                                            <p className={classes.recurrMenuText}></p>
                                            <Select native
                                                onChange={handleRecurrMonthlyWeek}
                                                value={recurrMonthlyWeek}>
                                                <option value={"First"}>{t("first")}</option>
                                                <option value={"Second"}>{t("second")}</option>
                                                <option value={"Third"}>{t("third")}</option>
                                                <option value={"Fourth"}>{t("fourth")}</option>
                                            </Select>
                                            <Select native
                                                onChange={handleRecurrMonthlyDay}
                                                value={recurrMonthlyDay}>
                                                <option value={"Sunday"}>{t("sunday")}</option>
                                                <option value={"Monday"}>{t("monday")}</option>
                                                <option value={"Tuesday"}>{t("tuesday")}</option>
                                                <option value={"Wednesday"}>{t("wednesday")}</option>
                                                <option value={"Thursday"}>{t("thursday")}</option>
                                                <option value={"Friday"}>{t("friday")}</option>
                                                <option value={"Saturday"}>{t("saturday")}</option>
                                            </Select>
                                            <p className={classes.recurrMenuText}>{t("everyMonth")}</p>
                                        </div>
                                        : <div>
                                            <FormLabel component="legend">{t("recurEveryWeekOn")}</FormLabel>
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={<Checkbox checked={state.sunday} onChange={handleChange('sunday')} name="sunday" />}
                                                    label={t("sunday")} />
                                                <FormControlLabel
                                                    control={<Checkbox checked={state.monday} onChange={handleChange('monday')} name="monday" />}
                                                    label={t("monday")} />
                                                <FormControlLabel
                                                    control={<Checkbox checked={state.tuesday} onChange={handleChange('tuesday')} name="tuesday" />}
                                                    label={t("tuesday")} />
                                                <FormControlLabel
                                                    control={<Checkbox checked={state.wednesday} onChange={handleChange('wednesday')} name="wednesday" />}
                                                    label={t("wednesday")} />
                                                <FormControlLabel
                                                    control={<Checkbox checked={state.thursday} onChange={handleChange('thursday')} name="thursday" />}
                                                    label={t("thursday")} />
                                                <FormControlLabel
                                                    control={<Checkbox checked={state.friday} onChange={handleChange('friday')} name="friday" />}
                                                    label={t("friday")} />
                                                <FormControlLabel
                                                    control={<Checkbox checked={state.saturday} onChange={handleChange('saturday')} name="saturday" />}
                                                    label={t("saturday")} />
                                            </FormGroup>
                                        </div>
                                    }
                                </FormControl>
                            </div>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            {t("cancel")}
                        </Button>
                        {recurMenuState.show && <Button color="primary" onClick={handleRecurringReportsDeleteEvent}>
                            {t("delete")}
                        </Button>}
                        <Button variant="contained" onClick={handleRecurringReportsSaveEvent} color="primary">
                            {t("save")}
                        </Button>
                    </DialogActions>
                </Dialog>

                
                <ColumnSelector columnOrder={props.columnOrder} 
                    checked={props.checked2} 
                    setChecked={props.setChecked2} 
                    setOrder={props.setOrder} 
                    disableColumns={props.disableColumns}/>
            </div>
        </Toolbar>
        </>
    );
}